// you need props in multiple places, so putting here


export default {
    value: {
        required: false,  // set it differently based on input type?
    },
    rules: { // we merge this with other things, and pass localRules to input
        type: [String, Object],
        default: "",
    },
    required: {  // boolean, OR json-logic object
        // WARNING - read the docs on vee-validate required - there are many types of required
        type: [Object, Boolean],
        default: false,
    },
    hidden: {  // boolean, OR json-logic object
        // hidden = still in data, but not visible
        type: [Object, Boolean],
        default: false,
    },
    removed: {  // boolean, OR json-logic object
        // removed = NOT in data, also not visible - but still in registry so we can intelligently hide/show it
        type: [Object, Boolean],
        default: false,
    },
    disabled: {  // boolean, OR json-logic object
        type: [Object, Boolean],
        default: false,
    },
    displayMode: {  // only boolean, OR json-logic object ?
        type: Boolean,
        default: false,
    },
    name: {
        type: String,
        required: true,
    },
    level: {  // passed in from schema parent - 0 is root
        type: Number,
        required: true, 
    },
    label: {
        type: String,
        default: "",
    },
    help: {
        type: String,
        required: false,
    },
    helpAbove: {
        type: Boolean,
        default: false,
    },
    // something about showing help text even in 'display' mode?
    placeholder: {
        type: String,
        default: "",
    },
    displayModePlaceholder: {  // placeholder JUST for displayMode = true
        type: String,
        default: "",  
    },
    vid: {  // maybe not needed????
        type: String,
        default: undefined,
    },
    type: {  // not relevant for some inputs -- just pass on all attrs?
        type: String,
        default: "text",
    },
    inline: {  // show it as INLINE (label/input) instead of stacked?  inline label width?
        type: Boolean,
        default: false,
    },
    labelWidth: {  // width of label for INLINE layout ONLY - '30%' or '2rem' or Number that gets used as a %
        type: [String, Number],
        default: '30%',
    },
    children: {  // schema children for GROUP fields, not actual input instances -- those are elsewhere
        type: Array,
        required: false,
    },
    ///// CLASSES
    labelClass: {
        type: [String, Object, Array],
        default: '',
    },
    helpClass: {
        type: [String, Object, Array],
        default: '',
    },
    inputClass: {
        type: [String, Object, Array],
        default: '',
    },
    errorClass: {
        type: [String, Object, Array],
        default: '',
    },
};